module.exports = __webpack_public_path__ + "img/arrow-video.6f30acea.svg";